export default __webpack_public_path__ + "static/media/idd1.9b092705.png";